'use client';

import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';
import { useRef, useState, useEffect } from 'react';
import { useOutsideClick } from '@/hooks';
import styles from './QuestionCards.module.scss';
import { ArrowDown } from '@/assets';

interface Props {
  card: Simplify<Content.BenefitsSliceQuestionsPrimaryCardsItem>;
}

const QuestionCard = ({ card }: Props) => {
  const [isOpenDescr, setIsOpenDescr] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const descWrapperRef = useRef<HTMLDivElement>(null);

  const cardRef = useOutsideClick(() => {
    if (isOpenDescr) setIsOpenDescr((prev) => !prev);
  });

  useEffect(() => {
    if (isOpenDescr && descWrapperRef.current) {
      setContentHeight(descWrapperRef.current.scrollHeight);
    } else if (!isOpenDescr) {
      setContentHeight(0);
    }
  }, [isOpenDescr]);

  const handleToggleDescription = () => {
    setIsOpenDescr((prev) => !prev);
  };

  return (
    <li
      ref={cardRef as React.RefObject<HTMLLIElement>}
      className={`${styles.card} ${isOpenDescr ? styles.isOpen : ''}`}
      onClick={handleToggleDescription}
    >
      <div className={styles.cardTop}>
        <span className={styles.title}>{card.card_title}</span>
        <button
          className={styles.toggleButton}
          type="button"
          aria-label={`Show info ${card.card_title}`}
        >
          <ArrowDown className={styles.arrow} />
        </button>
      </div>
      <div
        ref={descWrapperRef}
        style={{
          height: isOpenDescr
            ? contentHeight
              ? `${contentHeight}px`
              : 'auto'
            : '0px',
        }}
        className={`${styles.questionsDescWrapper} ${isOpenDescr ? styles.toggledDescWrapper : ''}`}
      >
        <p className={styles.description}>{card.description}</p>
      </div>
    </li>
  );
};

export default QuestionCard;
